export default __webpack_public_path__ + "static/media/Cronos.4a83131a.jpg";